module.exports = __webpack_public_path__ + "img/DiscountCode_Website.796b20a7.jpg";